var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 125,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.871 113.866v.014l.001.014c.152 5.477-4.424 10.095-10.123 10.095H11.134c-5.674 0-10.123-4.598-10.123-10.123V11.134C1.011 5.46 5.61 1.01 11.134 1.01h134.615c5.673 0 10.122 4.598 10.122 10.123v102.732Z",
    fill: "#F9FAFB",
    stroke: "#F3F4F6",
    strokeWidth: 2.022
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M102.561 52.065V73.8c0 8.053-5.04 13.733-13.094 13.733H66.401c-8.054 0-13.067-5.68-13.067-13.733V52.065c0-8.054 5.04-13.731 13.067-13.731h23.066c8.054 0 13.094 5.677 13.094 13.73Z",
    stroke: "#BAC7BB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60.084 74.816 4.075-4.301a3.737 3.737 0 0 1 5.28-.16l2.498 2.538a3.824 3.824 0 0 0 5.406.054c.098-.096 6.224-7.526 6.224-7.526a4.498 4.498 0 0 1 6.333-.61c.128.106 5.915 6.045 5.915 6.045",
    stroke: "#BAC7BB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M73.501 55.355a4.676 4.676 0 0 1-4.677 4.677 4.676 4.676 0 0 1-4.677-4.677 4.678 4.678 0 0 1 9.355 0Z",
    stroke: "#BAC7BB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotracking);
export default __webpack_public_path__ + "static/media/notracking.fc9e3b1b207c988c6c69c7160006fa8f.svg";
export { ForwardRef as ReactComponent };